export const INFERENCE_EVENT_GET_ATTEMPT = 'INFERENCE_EVENT_GET_ATTEMPT';
export const INFERENCE_EVENT_GET_SUCCESS = 'INFERENCE_EVENT_GET_SUCCESS';
export const INFERENCE_EVENT_GET_FAIL = 'INFERENCE_EVENT_GET_FAIL';

export const INFERENCE_EVENT_CLEAR = 'INFERENCE_EVENT_CLEAR';
